export enum ClinicCategory {
  Polyclinic = 0,
  Hospital = 1
}
